/**
 * Job Posting Translations - Portuguese (PT-BR)
 */
export const jobPt = {
  // Section headings
  'job.sections.aboutRole': 'Sobre a Vaga',
  'job.sections.responsibilities': 'Responsabilidades',
  'job.sections.requirements': 'Requisitos',
  'job.sections.technicalSkills': 'Requisitos Técnicos',
  'job.sections.behavioralSkills': 'Requisitos Comportamentais',
  'job.sections.benefits': 'Benefícios',
  'job.sections.compensation': 'Remuneração',

  // Work mode
  'job.workMode.remote': 'Remoto',
  'job.workMode.hybrid': 'Híbrido',
  'job.workMode.onsite': 'Presencial',

  // Employment type (backend: clt | pj | internship | temporary)
  'job.employmentType.clt': 'CLT',
  'job.employmentType.pj': 'PJ',
  'job.employmentType.internship': 'Estágio',
  'job.employmentType.temporary': 'Temporário',

  // Seniority
  'job.seniority.junior': 'Júnior',
  'job.seniority.mid': 'Pleno',
  'job.seniority.senior': 'Sênior',
  'job.seniority.lead': 'Lead',
  'job.seniority.principal': 'Principal',

  // Apply button
  'job.apply.button': 'Candidatar-se',
  'job.apply.ariaLabel': 'Candidatar-se para esta vaga',

  // Error states
  'job.error.invalidPosting': 'Vaga Inválida',
  'job.error.noJobId': 'Nenhum ID de vaga fornecido na URL.',
  'job.error.notFound': 'Vaga Não Encontrada',
  'job.error.unableToLoad': 'Não Foi Possível Carregar a Vaga',
  'job.error.notFoundDescription': 'Esta vaga não foi encontrada. Ela pode ter sido encerrada ou removida.',
  'job.error.unableToLoadDescription': 'Não foi possível carregar a vaga. Verifique sua conexão e tente novamente.',
}
